import ScratchBlocks from 'pico-blocks';

const B = ScratchBlocks.Arduino;

function inc () {
    B.includes_.picoLabSensors = '#include <PiCoLabSensors.h>';
}
function wireSetup () {
    B.includes_.wire = '#include <Wire.h>';
    B.setups_.picoLabSensors_wire = 'Wire.begin();';
}

// ── 7-Segment ────────────────────────────────────────────────────────────────
B['arduino_display_write7seg'] = function (block) {
    const digit = B.valueToCode(block, 'DIGIT', B.ORDER_ATOMIC) || '0';
    inc(); wireSetup();
    return `writeinto7segment(${digit});\n`;
};
B['arduino_display_clear7seg'] = function () { inc(); wireSetup(); return 'clear7segment();\n'; };
B['arduino_display_dot7seg']   = function () { inc(); wireSetup(); return 'writedotinto7segment();\n'; };

// ── LCD ──────────────────────────────────────────────────────────────────────
B['arduino_display_initLCD'] = function () {
    inc(); wireSetup();
    B.setups_.picoLabSensors_initLCD = 'initLCD();';
    return '';
};
B['arduino_display_clearLCD'] = function () { inc(); wireSetup(); return 'clearLCD();\n'; };
B['arduino_display_setCursorLCD'] = function (block) {
    const col = B.valueToCode(block, 'COL', B.ORDER_ATOMIC) || '0';
    const row = B.valueToCode(block, 'ROW', B.ORDER_ATOMIC) || '0';
    inc(); wireSetup();
    return `setCursorLCD(${col}, ${row});\n`;
};
B['arduino_display_printTextLCD'] = function (block) {
    const text = B.valueToCode(block, 'TEXT', B.ORDER_ATOMIC) || '""';
    inc(); wireSetup();
    return `printLCD(${text});\n`;
};
B['arduino_display_printNumberLCD'] = function (block) {
    const num = B.valueToCode(block, 'NUM', B.ORDER_ATOMIC) || '0';
    inc(); wireSetup();
    return `printLCD((int)(${num}));\n`;
};
B['arduino_display_backlightLCD'] = function (block) {
    const state = block.getFieldValue('STATE') || 'true';
    inc(); wireSetup();
    return `setBacklightLCD(${state});\n`;
};

// ── RGB LED ───────────────────────────────────────────────────────────────────
B['arduino_lights_initRGB'] = function () {
    inc(); B.setups_.picoLabSensors_initRGB = 'initRGB();'; return '';
};
B['arduino_lights_setRGB'] = function (block) {
    const r  = block.getFieldValue('R')  || 'false';
    const g  = block.getFieldValue('G')  || 'false';
    const bl = block.getFieldValue('B')  || 'false';
    inc();
    return `setRGB(${r}, ${g}, ${bl});\n`;
};
B['arduino_lights_setRGBPWM'] = function (block) {
    const r  = B.valueToCode(block, 'R', B.ORDER_ATOMIC) || '0';
    const g  = B.valueToCode(block, 'G', B.ORDER_ATOMIC) || '0';
    const bl = B.valueToCode(block, 'B', B.ORDER_ATOMIC) || '0';
    inc();
    return `setRGBPWM(${r}, ${g}, ${bl});\n`;
};
B['arduino_lights_clearRGB'] = function () { inc(); return 'clearRGB();\n'; };

// ── LEDs ─────────────────────────────────────────────────────────────────────
B['arduino_lights_initLEDs'] = function () {
    inc(); B.setups_.picoLabSensors_initLEDs = 'initLEDs();'; return '';
};
B['arduino_lights_setLED1'] = function (block) {
    const s = block.getFieldValue('STATE') || 'false'; inc(); return `setLED1(${s});\n`;
};
B['arduino_lights_setLED2'] = function (block) {
    const s = block.getFieldValue('STATE') || 'false'; inc(); return `setLED2(${s});\n`;
};
B['arduino_lights_clearLEDs'] = function () { inc(); return 'clearLEDs();\n'; };

// ── Buzzer ────────────────────────────────────────────────────────────────────
B['arduino_buzzer_initBuzzer'] = function () {
    inc(); B.setups_.picoLabSensors_initBuzzer = 'initBuzzer();'; return '';
};
B['arduino_buzzer_beepBuzzer'] = function (block) {
    const d = B.valueToCode(block, 'DURATION', B.ORDER_ATOMIC) || '500';
    inc(); return `beepBuzzer(${d});\n`;
};
B['arduino_buzzer_toneBuzzer'] = function (block) {
    const f = B.valueToCode(block, 'FREQ',     B.ORDER_ATOMIC) || '440';
    const d = B.valueToCode(block, 'DURATION', B.ORDER_ATOMIC) || '500';
    inc(); return `toneBuzzer(${f}, ${d});\n`;
};
B['arduino_buzzer_stopBuzzer'] = function () { inc(); return 'stopBuzzer();\n'; };

// ── Buttons ───────────────────────────────────────────────────────────────────
B['arduino_buttons_readButton'] = function () {
    inc(); return ['readButton()', B.ORDER_ATOMIC];
};
B['arduino_buttons_isButtonPressed'] = function (block) {
    const btn = block.getFieldValue('BTN') || '1';
    inc(); return [`(readButton() == ${btn})`, B.ORDER_ATOMIC];
};

// ── Potentiometer ─────────────────────────────────────────────────────────────
B['arduino_sensors_readPot']    = function () { inc(); return ['readPotentiometer()',    B.ORDER_ATOMIC]; };
B['arduino_sensors_readPotPct'] = function () { inc(); return ['readPotentiometerPct()', B.ORDER_ATOMIC]; };

// ── LDR ──────────────────────────────────────────────────────────────────────
B['arduino_sensors_readLDR']        = function () { inc(); return ['readLDR()',        B.ORDER_ATOMIC]; };
B['arduino_sensors_readLightLevel'] = function () { inc(); return ['readLightLevel()', B.ORDER_ATOMIC]; };
B['arduino_sensors_isDark']         = function () { inc(); return ['isDark()',         B.ORDER_ATOMIC]; };
B['arduino_sensors_isLight']        = function () { inc(); return ['isLight()',        B.ORDER_ATOMIC]; };

// ── Hall ──────────────────────────────────────────────────────────────────────
B['arduino_sensors_readHall']          = function () { inc(); return ['readHall()',          B.ORDER_ATOMIC]; };
B['arduino_sensors_isMagnetDetected']  = function () { inc(); return ['isMagnetDetected()',  B.ORDER_ATOMIC]; };
B['arduino_sensors_getMagnetPolarity'] = function () { inc(); return ['getMagnetPolarity()', B.ORDER_ATOMIC]; };

// ── IR Reflective ─────────────────────────────────────────────────────────────
B['arduino_sensors_readIRReflective'] = function () { inc(); return ['readIRReflective()', B.ORDER_ATOMIC]; };
B['arduino_sensors_isObjectDetected'] = function () { inc(); return ['isObjectDetected()', B.ORDER_ATOMIC]; };

// ── IR Remote ─────────────────────────────────────────────────────────────────
B['arduino_sensors_initIRReceiver'] = function () {
    inc(); B.setups_.picoLabSensors_initIR = 'initIRReceiver();'; return '';
};
B['arduino_sensors_hasIRSignal'] = function () { inc(); return ['hasIRSignal()', B.ORDER_ATOMIC]; };
B['arduino_sensors_readIRCode']  = function () { inc(); return ['readIRCode()',  B.ORDER_ATOMIC]; };
B['arduino_sensors_resumeIR']    = function () { inc(); return 'resumeIR();\n'; };

// ── DHT11 ─────────────────────────────────────────────────────────────────────
B['arduino_temperature_initDHT11'] = function () {
    inc(); B.setups_.picoLabSensors_initDHT11 = 'initDHT11();'; return '';
};
B['arduino_temperature_readTempDHT']     = function () { inc(); return ['readTemperatureDHT()', B.ORDER_ATOMIC]; };
B['arduino_temperature_readHumidityDHT'] = function () { inc(); return ['readHumidityDHT()',     B.ORDER_ATOMIC]; };

// ── DS18B20 ───────────────────────────────────────────────────────────────────
B['arduino_temperature_initDS18B20'] = function () {
    inc(); B.setups_.picoLabSensors_initDS18B20 = 'initDS18B20();'; return '';
};
B['arduino_temperature_readDS18B20'] = function () { inc(); return ['readDS18B20()', B.ORDER_ATOMIC]; };

// ── RTC ───────────────────────────────────────────────────────────────────────
B['arduino_clock_initRTC'] = function () {
    inc(); B.setups_.picoLabSensors_initRTC = 'initRTC();'; return '';
};
B['arduino_clock_setTimeRTC'] = function (block) {
    const h = B.valueToCode(block, 'H', B.ORDER_ATOMIC) || '12';
    const m = B.valueToCode(block, 'M', B.ORDER_ATOMIC) || '0';
    const s = B.valueToCode(block, 'S', B.ORDER_ATOMIC) || '0';
    inc(); return `setTimeRTC(${h}, ${m}, ${s});\n`;
};
B['arduino_clock_setDateRTC'] = function (block) {
    const day   = B.valueToCode(block, 'DAY',   B.ORDER_ATOMIC) || '1';
    const month = B.valueToCode(block, 'MONTH', B.ORDER_ATOMIC) || '1';
    const year  = B.valueToCode(block, 'YEAR',  B.ORDER_ATOMIC) || '2025';
    inc(); return `setDateRTC(${day}, ${month}, ${year});\n`;
};
B['arduino_clock_getRTCTime'] = function (block) {
    const field = block.getFieldValue('FIELD') || 'hour';
    inc();
    const fn = {hour: 'getHourRTC()', minute: 'getMinuteRTC()', second: 'getSecondRTC()'};
    return [fn[field] || 'getHourRTC()', B.ORDER_ATOMIC];
};
B['arduino_clock_getRTCDate'] = function (block) {
    const field = block.getFieldValue('FIELD') || 'day';
    inc();
    const fn = {day: 'getDayRTC()', month: 'getMonthRTC()', year: 'getYearRTC()'};
    return [fn[field] || 'getDayRTC()', B.ORDER_ATOMIC];
};
